import { PermissionStatus } from 'expo-location';

import {
  LOCATION_PRIMER_SUPPRESSION_FOREVER,
  LOCATION_PRIMER_SUPPRESSION_STORAGE_KEY,
  LOCATION_GRANT_TYPE_STORAGE_KEY,
  PUSH_NOTIFICATION_PRIMER_SUPPRESSION_FOREVER,
  PUSH_NOTIFICATION_PRIMER_SUPPRESSION_STORAGE_KEY,
} from '../permissions.machine.constants';
import { permissionsStorage } from '../permissions.machine.storage';
import {
  type Guard,
  type LocationPermissionStatus,
  type PushNotificationPermissionStatus,
} from '../permissions.machine.types';

// ─── Push ────────────────────────────────────────────────────────────────────

export const checkIfPushNotificationSuppressedForever: Guard = () =>
  readPushNotificationSuppressedUntil() === PUSH_NOTIFICATION_PRIMER_SUPPRESSION_FOREVER;

export const checkIfPushNotificationSuppressionActive: Guard = () =>
  readPushNotificationSuppressedUntil() > Date.now();

export const checkIfPushNotificationPermissionGranted: Guard<PushNotificationPermissionStatus> = (
  _args,
  params,
): boolean => params.status === PermissionStatus.GRANTED;

export const checkIfPushNotificationPermissionDenied: Guard<PushNotificationPermissionStatus> = (
  _args,
  params,
): boolean => params.status === PermissionStatus.DENIED && params.canAskAgain === false;

// ─── Location ────────────────────────────────────────────────────────────────

export const checkIfSuppressedForever: Guard = () =>
  readLocationSuppressedUntil() === LOCATION_PRIMER_SUPPRESSION_FOREVER;

export const checkIfSuppressionActive: Guard = () => readLocationSuppressedUntil() > Date.now();

export const checkIfLocationPermissionGranted: Guard<LocationPermissionStatus> = (
  _args,
  params,
): boolean => params.status === PermissionStatus.GRANTED;

export const checkIfLocationPermissionDenied: Guard<LocationPermissionStatus> = (
  _args,
  params,
): boolean => params.status === PermissionStatus.DENIED;

export const checkIfLocationGrantTypeAllowOnce: Guard = () =>
  permissionsStorage.getString(LOCATION_GRANT_TYPE_STORAGE_KEY) === 'allow_once';

// ─── Helpers ─────────────────────────────────────────────────────────────────

function readPushNotificationSuppressedUntil() {
  return permissionsStorage.getNumber(PUSH_NOTIFICATION_PRIMER_SUPPRESSION_STORAGE_KEY) ?? 0;
}

function readLocationSuppressedUntil() {
  return permissionsStorage.getNumber(LOCATION_PRIMER_SUPPRESSION_STORAGE_KEY) ?? 0;
}
